module.exports = __webpack_public_path__ + "assets/img/marriage-bottom-bg2.284e6a12.png";